import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { Skeleton } from "../ui/skeleton";

export interface OverviewCardItem {
  label: string;
  value: string;
  detail: string;
  icon: React.ReactNode;
}

interface OverviewCardsProps {
  cards: OverviewCardItem[];
  loading?: boolean;
}

export function OverviewCards({ cards, loading = false }: OverviewCardsProps) {
  const primaryTextStyle = {
    color: "color-mix(in srgb, var(--foreground) 77%, var(--surface))",
  } as const;
  const secondaryTextStyle = {
    color: "color-mix(in srgb, var(--foreground) 66%, var(--surface))",
  } as const;
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {cards.map((card) => (
        <Card key={card.label} className="stat-card">
          <CardHeader className="pb-3">
            {loading ? (
              <Skeleton className="h-4 w-28" />
            ) : (
              <CardDescription
                className="card-description-text"
                style={secondaryTextStyle}
              >
                {card.label}
              </CardDescription>
            )}
          </CardHeader>
          <CardContent>
            <div className="flex items-center gap-4">
              <div className="icon-box">
                {loading ? <Skeleton className="h-6 w-6 rounded-sm" /> : card.icon}
              </div>
              <div>
                {loading ? (
                  <>
                    <Skeleton className="h-8 w-24 mb-2" />
                    <Skeleton className="h-4 w-32" />
                  </>
                ) : (
                  <>
                    <p className="text-primary-heading">{card.value}</p>
                    <p className="text-sm" style={secondaryTextStyle}>
                      {card.detail}
                    </p>
                  </>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
